// extracted by mini-css-extract-plugin
module.exports = {"container":"qr_container__3-5Ld","qr":"qr_qr__3sJUk","buttons":"qr_buttons__3_Iin","button":"qr_button__2U4HS","shareLinks":"qr_shareLinks__3hQMw"};